import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import DarkModeToggle from 'front/components/ui/DarkModeToggle';
import { useTheme } from '../../../core/contexts/ThemeContext';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background:
    url('/images/global/member_bg_bottom1.png') no-repeat left bottom,
    url('/images/global/member_bg_bottom2.png') no-repeat right bottom,
    url('/images/global/member_bg.png') no-repeat center center;
  background-size: auto, auto, cover;

  html.dark-mode & {
    background:
      url('/images/global/member_bg_bottom1_dark.png') no-repeat left bottom,
      url('/images/global/member_bg_bottom2_dark.png') no-repeat right bottom,
      url('/images/global/member_bg_dark.png') no-repeat center center;
  }
`;

const Header = styled.header`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${props => props.theme.spacing.xl} ${props => props.theme.spacing.xl};
  & button {
    pointer-events: auto;
  }
`;

const Logo = styled.div`
  cursor: pointer;
  pointer-events: auto;
  html.dark-mode & img {
    filter: invert(1);
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 320px;
  gap: ${props => props.theme.spacing.xl};
  pointer-events: auto;
`;

const Title = styled.h1`
  font-size: ${props => props.theme.fontSize['2xl']};
  font-weight: ${props => props.theme.fontWeight.semibold};
  color: ${props => props.theme.colors.book.color1b};
  text-align: center;
`;

const Message = styled.div`
  font-size: ${props => props.theme.fontSize.base};
  color: ${props => props.theme.colors.book.color6b};
  padding-bottom: ${props => props.theme.spacing.md};
  text-align: center;
`;

const SubMessage = styled.div`
  font-size: ${props => props.theme.fontSize.sm};
  color: ${props => props.theme.colors.book.color6b};
  margin-bottom: ${props => props.theme.spacing['3xl']};
  text-align: center;
`;

const Button = styled.button`
  border-radius: ${props => props.theme.borderRadius.lg};
  background-color: ${props => props.theme.colors.book.color0b};
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSize.base};
  font-weight: ${props => props.theme.fontWeight.medium};
  cursor: pointer;
  transition: all 0.2s;
  width: 320px;
  height: 44px;
  box-shadow: ${props => props.theme.shadows.sm};

  &:hover {
    background-color: ${props => props.theme.colors.book.color3b};
  }

  &:active {
    transform: translateY(0);
  }
`;

const RegisterComplete: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <Container>
      <Header>
        <Logo onClick={() => navigate('/')}><img src="/images/global/logo.svg" alt="logo" /></Logo>
        <DarkModeToggle isDark={isDarkMode} onToggle={toggleDarkMode} />
      </Header>
      <Content>
        <Title>회원가입 완료</Title>
        <Message>
          회원가입이 완료 되었습니다.<br />
          서비스는 계정 승인 후에 이용 가능합니다.
        </Message>
        {/*
        <SubMessage>서비스는 계정 승인 후에 이용 가능합니다.</SubMessage>
        */}
        <Button onClick={() => navigate('/')}>
          메인으로 이동
        </Button>
      </Content>
    </Container>
  );
};

export default RegisterComplete;
